import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/store/user'
import AdminLayout from '@/layouts/AdminLayout.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/LoginView.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/',
      component: AdminLayout,
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/dashboard/DashboardView.vue'),
        },
        {
          path: 'orders',
          name: 'OrderList',
          component: () => import('@/views/order/OrderList.vue'),
        },
        {
          path: 'orders/:id',
          name: 'OrderDetail',
          component: () => import('@/views/order/OrderDetail.vue'),
        },
        {
          path: 'products',
          name: 'ProductList',
          component: () => import('@/views/product/ProductList.vue'),
        },
        {
          path: 'channels',
          name: 'ChannelList',
          component: () => import('@/views/channel/ChannelList.vue'),
        },
        {
          path: 'payment/create',
          name: 'PaymentCreate',
          component: () => import('@/views/payment/PaymentCreate.vue'),
        },
        {
          path: 'payment/query',
          name: 'PaymentQuery',
          component: () => import('@/views/payment/PaymentQuery.vue'),
        },
      ],
    },
    {
      // 404 catch-all route
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFound.vue'),
      meta: { requiresAuth: false },
    },
  ],
})

router.beforeEach((to, _from, next) => {
  const userStore = useUserStore()
  // 使用 meta.requiresAuth 判断（默认需要认证）
  const requiresAuth = to.meta.requiresAuth !== false
  if (requiresAuth && !userStore.isLoggedIn) {
    next('/login')
  } else if (to.path === '/login' && userStore.isLoggedIn) {
    next('/')
  } else {
    next()
  }
})

export default router
